import { Component, OnInit, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { HttpCustomerService } from 'src/service/httpcustomer.service';
import { CommonService } from 'src/service/common.service';
import { ActivatedRoute } from '@angular/router';
import { WebParameterContext } from '../../../../model/common';
import { MessageclientService } from '../../../../service/messageclient.service';
import { GridBaseCase } from '../../grid/grid.base.case';
declare var app;
@Component({
  selector: 'app-potential-membersdetail',
  templateUrl: './potential-membersdetail.page.html',
  styleUrls: ['./potential-membersdetail.page.scss'],
})
export class PotentialMembersdetailPage extends GridBaseCase implements OnInit  {
  tabsIndex: number = 0; // 计划分娩方式
  tabsIndexmom: number = 0; // 妈妈遇到的问题
  tabsIndexfeed: number = 0; // 计划喂养方式
  tabsIndexnestle: number = 0; // 奶粉品牌
  @Input() info: any;
  @Input() StageTitle:any;
  @Input() Stage:any;
  _type: any = "";//判断类型
  labelData: any = {
    TAT10006:{},
    TAT10005:{},
    TAT10002:{},
    TAT10004:{}
  };
  submitData = [];//提交前数据
  isYun:boolean = true;//是否孕期
  constructor(
    public modalController: ModalController,
    private http: HttpCustomerService,
    private activaRouter: ActivatedRoute,
    private msg: MessageclientService,
    private com: CommonService,
  ) { 
    super();
  }

  ngOnInit() {
    let stage:number=parseInt(this.Stage);
    if(stage<0)
    {
      this.isYun=false;
    }
    this.alreadyTags();
    this.getLabelDatas();
    console.log(this.StageTitle,"显示得bu")
    console.log(this.Stage);
  
  }
  Elevent(item, i, num) {
    const that = this;
    switch (num) {
    
      case 1:
        // that.tabsIndex= i;
        that.labelData['TAT10006']['subList'].forEach(c => {
          c["isCheck"] = false;
        });
        item["isCheck"] = true;
    
        break;
      case 2:
        // that.tabsIndexmom= i;
        that.labelData['TAT10005']['subList'].forEach(c => {
          c["isCheck"] = false;
        });
        item["isCheck"] = true;
        break;
      case 3:
        that.labelData['TAT10002']['subList'].forEach(c => {
          c["isCheck"] = false;
        });
        item["isCheck"] = true;
        // that.tabsIndexfeed= i;
        break;
      case 4:
        // that.labelData['TAT10004'].forEach(c => {
        //   c["isCheck"] = false;
        // });
        item["isCheck"] = !item["isCheck"];
        // that.tabsIndexnestle= i;
        break;
    }

    let itemIsPush = false;
    that.submitData.forEach(current => {
      if (current["a_Code"] == item["a_Code"]) {
        itemIsPush = true;
        current["isCheck"] = item["isCheck"];
      }
    })
    if (!itemIsPush) {
      that.submitData.push(item);
    }

  }
  // 取消
  dismissModal() {
    const that = this;
    this.modalController.dismiss({
      "modalStatus": false,
      "type": that._type,
      "info": '0'
    });
  }
  // 确定
  comfireModal() {
    const that = this;
    let _array: Array<any> = new Array<any>();
    debugger;
        // that.tabsIndex= i;
        let _arrayList:Array<any> = new Array<any>();
        that.labelData['TAT10006']['subList'].forEach(c => {
          if(c["isCheck"]){
            _arrayList.push(c);
          }
        });
       
      
        that.labelData['TAT10005']['subList'].forEach(c => {
          if(c["isCheck"]){
            _arrayList.push(c);
          }
        });
       
      
        that.labelData['TAT10002']['subList'].forEach(c => {
          if(c["isCheck"]){
            _arrayList.push(c);
          }
        });
      that.labelData['TAT10004']['subList'].forEach(c => {
        if(c["isCheck"]){
          _arrayList.push(c);
        }
        });
    _arrayList.forEach(item=>{
      if(item["isCheck"]){
        _array.push({
          a_FK_MembersInfoManagement_ID:that.info["id"],
          a_FK_TBTagManage_ID:item["a_ID"],
          Code:item["a_Code"]
        })
      }
    })
    // SpecialParameter
    let body = {};

    body["ConfigName"] = "TBMemberTagXML";
    body["OpType"] = "edite";
    body["ConfigType"] = "form";
    body["SpecialParameter"] = that.info["mobile"];
    if(_array.length == 0){
      that.msg.Alert("请选择会员标签！");
      return;
    }
    body["RequestBody"] = JSON.stringify(_array);
    that.msg.Confirm("确认保存？").then(data=>{
      if(data){
        that.http.post(app.DEFAULTURL, body).then(data => {
          /****判断是否第一页end****/
          if (data.ResponseMessage.Success) {
            that.msg.Alert("保存成功！").then(data=>{
              that.modalController.dismiss({
                "modalStatus": true,
                "type": that._type,
                "info": "是的"
              });
            })
          } else {
            that.msg.Alert(data.ResponseMessage.ErrorMessage);
          }
        }).catch(error=>{
          that.msg.Alert('网络异常，请稍后再试！');
        })
      }
    })
    // that.modalController.dismiss({
    //   "modalStatus": true,
    //   "type": that._type,
    //   "info": "是的"
    // });
  }

  getLabelDatas() {
    var that = this;
    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    let body = {};

    body["ConfigName"] = "TBTagManageXML";
    body["OpType"] = "query";
    body["ConfigType"] = "view";
    body["RowsPerPage"] = 1000;
    body["PageNumber"] = 1;
    that.http.post(app.DEFAULTURL, body).then(data => {
      /****判断是否第一页end****/
      if (data.ResponseMessage.Success) {
        data.Status.Datas.forEach(item => {
          item["isCheck"] = false;
        });
        that.alreadyTags().then(res=>{
          let editeArray:Array<any> = res;
          data.Status.Datas.forEach(item => {
            editeArray.forEach(itemcheck=>{
              if(item.a_Code==itemcheck.d_Code){
                item["isCheck"] = true;
              }
            });
          });
          that.rootInit(data.Status.Datas);
        }).catch(err=>{
          that.rootInit(data.Status.Datas);
        });
        // that.labelData["TAT10006"]['subList'].forEach(item=>{
        //   if(item["a_Code"] == "MT10029"){
        //     item["isCheck"] = false;
        //   }
        // })
        console.log(that.labelData, "------------------TBTagManageXMLTBTagManageXML----------------------------");
      } else {
        that.msg.Alert(data.ResponseMessage.ErrorMessage);
      }

    })
  }
//处理是否选中逻辑判断
  rootInit(tempArray:Array<any>){
    const that=this;
    let currentData = [];
    tempArray.forEach(item => {
      let itemIsPush = false;
      currentData.forEach(item2 => {
        if (item["b_Code"] == item2["b_Code"]) {
          item2["subList"].push(item);
          itemIsPush = true;
        }
      })
      if (!itemIsPush) {
        currentData.push({
          name: item["b_Name"],
          b_Code: item["b_Code"],
          otherName:item["b_AnotherName"],
          subList: [item]
        });
      }
    })
    currentData.forEach(item => {
      that.labelData[item["b_Code"]] = item;
    });
  }
   //加载已有用户标签
   alreadyTags():Promise<any> {
    let that = this;
     return new Promise<any>((resolve,reject)=>{
      const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
      let body = new WebParameterContext();
      body.Account = that.com.GetAccount;
      body.OpType = "query";
      body.ConfigType = "view";
      body.RowsPerPage = app.RowsPerPage;
      body.PageNumber = 1;
      body.Client.PageName = PageName;
      body.ConfigName = "TBMemberTagXML";
      body.Client.ApiType = "Element";
      body.Client.ClientType = 2;
      let typeObj = {};
      typeObj["a_FK_MembersInfoManagement_ID"] =that.info["id"];
      // body.SpecialParameter = "StopWork";
      body.RequestBody = JSON.stringify(typeObj);
  
      that.http.post(app.DEFAULTURL, body).then(data => {
        /****判断是否第一页begin****/
        /****判断是否第一页end****/
        if (data.ResponseMessage.Success) {
            if(data.Status.Datas.length>0){
              resolve(data.Status.Datas);
            }else{
              reject(false);
            }
        }else{
          reject(false);
        }
        // console.log(that.labelData);
      }).catch(error => {
        reject(false);
      });
     })
  }
}
